import { ExtendedWalletClient } from "@sdk/auth/types";
import { SdkClient } from "@sdk/index";
import { IxEventType, QuickTradeNotificationData } from "@sdk/notification/types";
import { IxEnv, SdkConfig } from "@sdk/shared/types/sdk.types";
import chains from "@shared/src/config/chains";

// Global event handlers registry

const config: SdkConfig = {
  defaultChainId: chains[0].id,
  defaultCurrency: "GHS",
  defaultToken: "USDC",
  env: (process.env.NEXT_PUBLIC_IX_ENV as IxEnv) || "dev",
};
let _sdk = new SdkClient(config);

export function getSdk() {
  if (!_sdk) {
    _sdk = new SdkClient(config);
  }
  return _sdk;
}

/**
 * Authenticate the SDK instance once. Multiple calls are safe; token is cached internally.
 */
export async function ensureSdkAuthenticated(walletClient: ExtendedWalletClient, jwt?: string) {
  const sdk = getSdk();
  // If already authenticated, skip
  if (sdk.auth.getToken?.() || !walletClient) return;
  try {
    await sdk.auth.authenticate({ walletClient, jwt });
  } catch (error) {
    console.error("SDK authentication failed", error);
    throw error;
  }
}

// Export types for convenience
export type { QuickTradeNotificationData };
export { IxEventType };
